import { ExternalLink } from "lucide-react";
import { CA, DEXSCREENER_EMBED, DEXSCREENER_URL } from "../config";
import CopyButton from "./CopyButton";
import LiveStats from "./LiveStats";
import Reveal, { SectionHead } from "./Reveal";

const STATS = [
    { label: "TOKEN", value: "$BALD" },
    { label: "NETWORK", value: "SOLANA" },
    { label: "TOTAL SUPPLY", value: "1,000,000,000" },
];

export default function TokenInfo() {
    return (
        <section id="tokenomics" data-testid="token-info-section" className="relative scroll-mt-24 py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
                <SectionHead kicker="TOKEN INFORMATION" title="THE BALD NUMBERS" />

                <div className="mt-14 grid gap-5 md:grid-cols-3">
                    {STATS.map((s, i) => (
                        <Reveal key={s.label} delay={i * 0.1} className="h-full">
                            <div
                                data-testid={`token-stat-${s.label.toLowerCase().replace(/ /g, "-")}`}
                                className="glass glass-hover flex h-full flex-col items-center gap-3 rounded-2xl p-8 text-center"
                            >
                                <span className="kicker">{s.label}</span>
                                <span className="headline text-3xl text-white md:text-4xl">{s.value}</span>
                            </div>
                        </Reveal>
                    ))}
                    <Reveal delay={0.3} className="md:col-span-3">
                        <div
                            data-testid="token-contract-card"
                            className="glass glass-hover flex flex-col items-center gap-4 rounded-2xl p-8 text-center"
                        >
                            <span className="kicker">CONTRACT</span>
                            <span className="break-all font-mono text-sm text-cyan-300 md:text-lg">{CA}</span>
                            <CopyButton
                                testId="tokenomics-copy-ca-button"
                                label="COPY CONTRACT"
                                className="btn-ghost"
                            />
                        </div>
                    </Reveal>
                </div>

                <LiveStats />

                <Reveal delay={0.15} className="mt-12">
                    <div className="glass overflow-hidden rounded-2xl">
                        <div className="flex items-center justify-between border-b border-cyan-400/10 px-5 py-3">
                            <div className="flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-widest text-slate-400">
                                <span className="h-2 w-2 rounded-full bg-green-400 animate-pulse-dot" />
                                LIVE CHART — DEXSCREENER
                            </div>
                            <a
                                href={DEXSCREENER_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="token-open-dexscreener-link"
                                className="flex items-center gap-1.5 font-mono text-xs font-bold uppercase tracking-widest text-cyan-300 hover:text-cyan-100"
                            >
                                OPEN DEXSCREENER <ExternalLink className="h-3.5 w-3.5" />
                            </a>
                        </div>
                        <iframe
                            src={DEXSCREENER_EMBED}
                            title="DexScreener live chart for $BALD"
                            loading="lazy"
                            data-testid="dexscreener-chart-embed"
                            className="h-[420px] w-full border-0 md:h-[560px]"
                        />
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
